var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 104,
    viewBox: "0 0 83 104",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3622 0C8.44384 0 3.59946 4.62626 3.20637 10.4808L3.18052 11.2511V88.7489C3.18052 94.704 7.77792 99.5784 13.5963 99.974L14.3622 100H71.512C77.4301 100 82.2744 95.374 82.6678 89.5195L82.6936 88.7489V11.2511C82.6936 5.29617 78.0959 0.421792 72.2775 0.0259532L71.512 0H14.3622ZM14.3622 7.50074H71.512C73.3989 7.50074 74.9583 8.91163 75.2051 10.7422L75.2392 11.2511V88.7489C75.2392 90.6476 73.837 92.2167 72.0177 92.4652L71.512 92.4993H14.3622C12.4752 92.4993 10.9157 91.0886 10.6687 89.2579L10.6349 88.7489V11.2511C10.6349 9.35242 12.0369 7.78332 13.8563 7.53499L14.3622 7.50074Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.749 71C67.749 68.7909 66.0094 67 63.8634 67H19.8266C17.6807 67 15.941 68.7909 15.941 71C15.941 73.2091 17.6807 75 19.8266 75H63.8634C66.0094 75 67.749 73.2091 67.749 71Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.749 30C67.749 27.7909 66.0094 26 63.8634 26H19.8266C17.6807 26 15.941 27.7909 15.941 30C15.941 32.2092 17.6807 34 19.8266 34H63.8634C66.0094 34 67.749 32.2092 67.749 30Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.749 50.5C67.749 48.5671 66.0094 47 63.8634 47H19.8266C17.6807 47 15.941 48.5671 15.941 50.5C15.941 52.4329 17.6807 54 19.8266 54H63.8634C66.0094 54 67.749 52.4329 67.749 50.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/Page.effe7c0713230a716e47362887343ed7.svg";
export { ForwardRef as ReactComponent };